
import { defineComponent, PropType, computed } from 'vue'
import ConfirmInput from '@/components/organisms/dms/common/ConfirmInput.vue'
import { AutoCollectUrl } from '@/data/dms/dmsData'

export default defineComponent({
  name: 'UrlConfirm',
  components: {
    ConfirmInput
  },
  props: {
    modelValue: {
      type: Object as PropType<AutoCollectUrl>
    }
  },
  setup (props, { emit }) {
    const state = computed({
      get: () => props.modelValue,
      set: (state) =>
        emit('update:modelValue', state)
    })
    return {
      props,
      state
    }
  }
})
